import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  TuiTextfieldControllerModule,
  TuiInputModule,
  TuiInputDateModule,
  TuiInputNumberModule,
} from '@taiga-ui/legacy';
import {
  TuiLoader,
  TuiScrollbar,
  TuiScrollable,
  TuiGroup,
  TuiDropdown,
  TuiButton,
  TuiHint,
  TuiInitialsPipe,
  TuiAutoColorPipe,
} from '@taiga-ui/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { GroupInfoModule } from '@src/app/modules/group-info';
import { OrganisationInfoModule } from '@src/app/modules/organisations/organisation-info';
import { SearchGroupsModule } from '@src/app/shared/search-groups';
import { UserInfoModule } from '@src/app/modules/user-info';
import { SharedModule } from '@src/app/shared';
import { ComponentsModule } from '@src/app/components';
import { CustomNamesTabsModule } from '@src/app/modules/custom-name-tabs';
import { NavigationModule } from '@src/app/modules/navigation';
import { GroupInfoTelegramModule } from '@src/app/modules/telegram';
import { ActionsModule } from '@src/app/modules/actions';
import { NewListModule } from '@src/app/modules/list';
import { PhotoModule } from '@src/app/modules/photo';
import { BaseChatsListModule } from '@src/app/modules/internal-messenger';

import { OrganisationRouting } from './organisation.routing';
import { OrganisationComponent } from './organisation.component';
import { OrganisationPersonalComponent } from './organisation-personal/organisation-personal.component';
import { OrganisationCommitteesComponent } from './organisation-committees/organisation-committees.component';
import { OrganisationConfigsComponent } from './organisation-configs/organisation-configs.component';

@NgModule({
  declarations: [
    OrganisationComponent,
    OrganisationPersonalComponent,
    OrganisationCommitteesComponent,
    OrganisationConfigsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    GroupInfoModule,
    NgxPermissionsModule,
    OrganisationInfoModule,
    OrganisationRouting,
    ReactiveFormsModule,
    RouterModule,
    SearchGroupsModule,
    SharedModule,
    TuiButton,
    TuiGroup,
    TuiInputModule,
    TuiInputNumberModule,
    TuiInputDateModule,
    ...TuiHint,
    TuiLoader,
    TuiScrollbar,
    TuiScrollable,
    TuiTextfieldControllerModule,
    UserInfoModule,
    ...TuiDropdown,
    ComponentsModule,
    CustomNamesTabsModule,
    NavigationModule,
    GroupInfoTelegramModule,
    ActionsModule,
    NewListModule,
    TuiAutoColorPipe,
    TuiInitialsPipe,
    PhotoModule,
    BaseChatsListModule,
  ],
  exports: [OrganisationComponent],
})
export class OrganisationModule {}
